import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/icons/myApprovalLaunchico@2x.png'
import _imports_1 from '../../assets/icons/myApprovalMyico@2x.png'
import _imports_2 from '../../assets/icons/myApprovalCopyico@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-4f7b991e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-10 pt-10 bg-page overflow-hidden min-h-screen pb-20" }
const _hoisted_2 = { class: "bg-white px-10 pt-10 pb-15 rounded-8" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-default leading-20 font-500 text-15" }, "我的审批", -1))
const _hoisted_4 = { class: "flex justify-center text-default leading-20 text-13 mt-15" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "relative w-44 h-44" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-44 h-44",
    src: _imports_0
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-10" }, "我发起的", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "relative w-44 h-44" }
const _hoisted_9 = {
  class: "absolute bg-orange right--4 top--4 z-1 text-white h-12 rounded-full p-2 flex items-center justify-center",
  style: {"border":"2px solid #fff","min-width":"12px"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-44 h-44",
  src: _imports_1
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-10" }, "我审批的", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "relative w-44 h-44" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-44 h-44",
    src: _imports_2
  })
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-10" }, "抄送我的", -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-default text-15 leading-20 font-500 mt-15 mb-10" }, "发起审批", -1))
const _hoisted_16 = { key: 1 }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "flex flex-1 items-center" }
const _hoisted_19 = { class: "text-15 text-default font-500 truncate flex-1" }
const _hoisted_20 = { class: "relative pt-40" }
const _hoisted_21 = {
  class: "share-image",
  ref: "captureArea"
}
const _hoisted_22 = { class: "text-20 text-white leading-20 font-500 text-center pt-24 mb-20" }
const _hoisted_23 = { class: "share-content relative flex flex-col" }
const _hoisted_24 = { class: "w-full px-24 box-sizing" }
const _hoisted_25 = { class: "text-16 font-500 leading-20 text-default mb-8 pt-20 w-full" }
const _hoisted_26 = { class: "text-gray text-14 leading-20 line-clamp-2" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-14 text-default leading-20 absolute bottom-310 w-full text-center" }, " 分享给您的同事发起审批吧 ", -1))
const _hoisted_28 = { class: "w-full flex justify-center" }
const _hoisted_29 = ["src"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full box-sizing text-14 text-theme text-500 leading-20 text-center absolute bottom-26" }, [
  /*#__PURE__*/_createTextVNode(" 使用优服APP或微信扫一扫"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("扫描二维码发起审批 ")
], -1))
const _hoisted_31 = { key: 0 }
const _hoisted_32 = ["src"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-10 bg-white text-theme h-48 leading-48 text-center text-16 rounded-8 font-500" }, " 长按保存二维码 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyPage = _resolveComponent("EmptyPage")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "flex-1 flex flex-col items-center",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toMyApproval(0)))
          }, _hoisted_7),
          _createElementVNode("div", {
            class: "flex-1 flex flex-col items-center",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toMyApproval(1)))
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.unapprovedTotal), 1),
              _hoisted_10
            ]),
            _hoisted_11
          ]),
          _createElementVNode("div", {
            class: "flex-1 flex flex-col items-center",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toMyApproval(2)))
          }, _hoisted_14)
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_15,
        (_ctx.approvalTempList.length === 0)
          ? (_openBlock(), _createBlock(_component_EmptyPage, {
              key: 0,
              msg: "暂无可用审批"
            }))
          : (_openBlock(), _createElementBlock("ul", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.approvalTempList, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.id,
                  class: "flex justify-between bg-white py-10 px-12 items-center mb-8 rounded-8 overflow-hidden",
                  onClick: ($event: any) => (_ctx.toApproval(item.id))
                }, [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_van_image, {
                      class: "w-40 h-40 rounded-2 mr-10",
                      src: item.icon
                    }, null, 8, ["src"]),
                    _createElementVNode("div", _hoisted_19, _toDisplayString(item.name), 1)
                  ])
                ], 8, _hoisted_17))
              }), 128))
            ]))
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.popupShow,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.popupShow) = $event)),
      style: { width: '80%', background: 'none !important' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.userInfo?.shop_name), 1),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, " \"" + _toDisplayString(_ctx.shareTempItem.name) + "\" 的审批单 ", 1),
                _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.shareTempItem.desc), 1)
              ]),
              _hoisted_27,
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("img", {
                  class: "absolute bottom-80 rounded-6 overflow-hidden w-180 h-180",
                  src: _ctx.shareTempItem.qrcode
                }, null, 8, _hoisted_29)
              ]),
              _hoisted_30
            ])
          ], 512),
          _createVNode(_component_van_icon, {
            name: "close",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.popupShow = false)),
            class: "text-white absolute right-0 top-0 text-30"
          }),
          (_ctx.generatedImage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createElementVNode("img", {
                  src: _ctx.generatedImage,
                  alt: "生成的分享图片",
                  class: "w-full rounded-lg"
                }, null, 8, _hoisted_32)
              ]))
            : _createCommentVNode("", true),
          _hoisted_33
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}